// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingPlaceholder_loading__35fZA"};